(() => {
  if (customElements.get('nolera-stories')) return;
  class NoleraStories extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.play = this.querySelector('[data-play]');
      this.addEventListener('click', e => {
        const button = e.target.closest('button');
        if (!button) return;
        if (button.matches('[data-play]')) {
          this.paused = !this.paused;
          this.schedule();
        } else if (button.matches('[data-next], [data-prev], [data-dot]')) {
          this.paused = true;
          this.show(button.matches('[data-dot]') ? Number(button.dataset.dot) : this.index + (button.matches('[data-next]') ? 1 : -1), true);
        }
      }, options);
      this.addEventListener('focusin', () => { this.paused = true; this.schedule(); }, options);
      this.addEventListener('pointerdown', e => { this.startX = e.clientX; this.startY = e.clientY; this.paused = true; this.schedule(); }, options);
      this.addEventListener('pointerup', e => {
        const x = e.clientX - this.startX, y = e.clientY - this.startY;
        if (Math.abs(x) > 55 && Math.abs(x) > Math.abs(y) * 1.5) this.show(this.index + (x < 0 ? 1 : -1), true);
      }, options);
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault(); this.paused = true;
          this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.schedule(); }, options);
      document.addEventListener('shopify:block:select', e => {
        const index = this.slides.findIndex(slide => slide.id === 'Story-' + e.detail.blockId);
        if (index >= 0) { this.paused = true; this.show(index, true); }
      }, options);
      this.schedule();
    }
    show(index, announce = false) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
        if (this.dots[i]) {
          if (active) this.dots[i].setAttribute('aria-current', 'true');
          else this.dots[i].removeAttribute('aria-current');
        }
      });
      if (announce) this.querySelector('[data-status]').textContent = 'Story ' + (this.index + 1) + ' of ' + this.slides.length;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const running = !this.paused && !this.motion.matches && !document.hidden && this.slides.length > 1;
      if (this.play) {
        this.play.textContent = running ? 'Pause' : 'Play';
        this.play.setAttribute('aria-label', running ? 'Pause automatic stories' : 'Play automatic stories');
        this.play.disabled = this.motion.matches;
        if (this.motion.matches) this.play.setAttribute('aria-label', 'Automatic motion disabled by your preference');
      }
      if (running) this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
  }
  customElements.define('nolera-stories', NoleraStories);
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const menu = document.querySelector('.ne-mobile-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.addEventListener('click', e => {
    if (e.target.closest('.ne-mobile-menu nav a')) e.target.closest('.ne-mobile-menu').open = false;
  });
  const syncBag = () => {
    fetch((window.routes?.cart_url || '/cart') + '.js')
      .then(r => { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
      .then(cart => document.querySelectorAll('[data-ne-count]').forEach(el => el.textContent = cart.item_count))
      .catch(() => {});
  };
  document.addEventListener('cartUpdated', syncBag);
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, syncBag);
  }, { once: true });

  document.documentElement.classList.remove('ne-motion');
  const revealSelector = '.ne-section,.ne-story,.ne-values,.ne-newsletter';
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const animations = new Set();
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      revealObserver.unobserve(entry.target);
      if (reducedMotion.matches || window.Shopify?.designMode || typeof entry.target.animate !== 'function') return;
      try {
        const animation = entry.target.animate([
          { opacity: 0, transform: 'translateY(18px)' },
          { opacity: 1, transform: 'none' }
        ], { duration: 650, easing: 'cubic-bezier(.2,.7,.2,1)' });
        animations.add(animation);
        animation.addEventListener('finish', () => animations.delete(animation), { once: true });
        animation.addEventListener('cancel', () => animations.delete(animation), { once: true });
      } catch (_) {}
    });
  }, { threshold: 0.08 }) : null;
  const initializeReveals = (root = document) => {
    const items = [...root.querySelectorAll(revealSelector)];
    if (root.matches?.(revealSelector)) items.unshift(root);
    items.forEach(item => {
      item.classList.add('ne-in-view');
      if (seen.has(item)) return;
      seen.add(item);
      if (!reducedMotion.matches && !window.Shopify?.designMode) revealObserver?.observe(item);
    });
  };
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) animations.forEach(animation => animation.cancel());
  });
  initializeReveals();
  document.addEventListener('shopify:section:load', event => initializeReveals(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(revealSelector).forEach(item => revealObserver?.unobserve(item));
    if (event.target.matches?.(revealSelector)) revealObserver?.unobserve(event.target);
  });
})();